import { Box, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";

const TOPBAR_HEIGHT = 74;

export const OuterWrapper = styled(motion.div)(() => ({
  position: "relative",
  width: "100%",
  height: "100%",
  backgroundColor: "white",
  display: "flex",
  flexDirection: "column",
  overflow: "visible",
  borderLeft: "1px solid #E6DEEC",
}));

export const TopBarWrapper = styled(Stack)(({ theme }) => ({
  position: "relative",
  // Styling a element here because I had a hard time doing `styled(CustomLink)`
  "& > .frame-editor-topbar_close": {
    position: "absolute",
    left: "-16px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "32px",
    height: "32px",
    color: theme.palette.text.primary,
    border: "1px solid #E6DEEC",
    backgroundColor: "white",
    borderRadius: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.grey[100],
    },
  },
  "& > .frame-editor-topbar_close:focus-visible": {
    outline: "none",
  },
}));

export const TopBar = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "16px",
  padding: "0 42px",
  height: TOPBAR_HEIGHT,
}));

export const Title = styled(Typography)(() => ({
  fontSize: 20,
  fontWeight: 500,
  padding: "22px 0",
  marginRight: "auto",
}));

export const IframePreview = styled("iframe")<{
  selectedDevice?: "desktop" | "mobile";
}>(({ selectedDevice }) => ({
  width: selectedDevice === "mobile" ? "390px" : "100%",
  height: `100%`,
  border: 0,
  borderTop: "1px solid #E6DEEC",
  margin: selectedDevice === "mobile" ? "0 auto" : "0",
  backgroundColor: "white",
}));
